<!--新增坏件单-->
<template>
  <el-dialog
    :title="getTitle()"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="medium-dialog"
  >
    <div ref="print1" style="width: 850px;margin: 0 auto;">
      <p :style="{display:showtitle1,textAlign:'center',fontSize:'18px',lineHeight:'40px'}">{{getTitle()}}</p>
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
             class="query-table">
        <tr class="noborder">
          <td align="right" width="60">入&nbsp;&nbsp;&nbsp;&nbsp;库：</td>
          <td width="140">
            <el-select v-model="controlData.cangkucode" placeholder="请选择" size="mini" @change="changename">
              <el-option
                v-for="item in jxcstoreData"
                :key="item.cangkucode"
                :label="item.cangkuname"
                :value="item.cangkucode">
              </el-option>
            </el-select>
          </td>
          <td align="right" width="80">责任人：</td>
          <td colspan="4">
            <CommonTree ref="treeDserial" :treeHeight="180" :searchText="form.applyby" :inputSize="'mini'"
                        @check="checktree1"></CommonTree>
          </td>
        </tr>
        <tr class="noborder">
          <td align="right">产&nbsp;&nbsp;品&nbsp;&nbsp;名：</td>
          <td colspan="6">
            <CommonTree ref="treeSeed" :inputSize="'mini'" :defineDataSource="true" @bindData="bindData"
                        :isShowCheckBox="false" :treeWidth="600"
                        :treeHeight="400" :searchText="form.seedname"
                        @check="afterSelectCode"></CommonTree>
          </td>
        </tr>
        <tr class="noborder">
          <td align="right" width="60">入库原因：</td>
          <td colspan="5">
            <el-radio-group v-model="ordername">
            <el-radio label="验光原因">验光原因</el-radio>
            <el-radio label="顾客原因">顾客原因</el-radio>
            <el-radio label="质量问题">质量问题</el-radio>
            <el-radio label="加工损坏">加工损坏</el-radio>
            <el-radio label="商品过期">商品过期</el-radio>
            <el-radio label="其他原因">其他原因</el-radio>
          </el-radio-group>
          </td>
        </tr>
        <tr class="noborder">
          <td>备注：</td>
          <td colspan="5">
            <textarea style="width: 100%;height: 40px" v-model="controlData.remark"></textarea>
          </td>
        </tr>
        <tr class="noborder" v-if="addtype==1">
          <td align="right" width="60">供应商：</td>
          <td width="140">
            <el-select v-model="controlData.pcustomerserial" placeholder="请选择" size="mini" @change="changepcu">
              <el-option
                v-for="item in ptableData"
                :key="item.customerserial"
                :label="item.deptname"
                :value="item.customerserial">
              </el-option>
            </el-select>
          </td>
          <td align="right" width="80">地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：</td>
          <td width="220">{{controlData.caddress}}</td>
          <td align="right" width="60">联系人&nbsp;&nbsp;&nbsp;:</td>
          <td width="140">{{controlData.clinkman!=null ||
            controlData.clinkmantel!=null?controlData.clinkman+controlData.clinkmantel:" "}}
          </td>
        </tr>
        <tr class="noborder" v-if="addtype==1">
          <td align="right">供应号：</td>
          <td>
            <el-input v-model="tracknum" size="mini" ref="tracknum" placeholder="请输入供应商单号" @change="scanTracknum"
                      onfocus="this.select()"></el-input>
          </td>
          <td align="right">跟踪号：</td>
          <td>
            <el-input v-model="logisticstracknum" size="mini" ref="logisticstracknum" placeholder="请输入跟踪单号"
                      onfocus="this.select()"
            ></el-input>
          </td>
          <td align="right"></td>
          <td></td>
        </tr>
        <tr class="noborder">
          <td colspan="6">
            <el-table
              :data="tableData"
              :height="tableHeight(200)"
              size="mini"
              stripe
              border
              style="width: 100%;">
              <el-table-column
                type="index"
                :index="indexMethod"
                align="center"
                label="序号"
                width="50">
              </el-table-column>
              <el-table-column
                prop="seedname" :show-overflow-tooltip="true"
                label="名称"
                align="left"
                header-align="center">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" v-if="isyinxin"
                               label="注册证号"
                               align="left" width="160"
                               header-align="center">
                <template slot-scope="scope">
                  {{getBarcode(scope.row,'certno')}}
                </template>
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" v-if="isyinxin"
                               label="失效日期"
                               align="left"  width="100"
                               header-align="center">
                <template slot-scope="scope">
                  {{getBarcode(scope.row,'endtime')}}
                </template>
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" v-if="isyinxin"
                               label="批次号"
                               align="left" width="130"
                               header-align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.barcode" size="mini" v-if="scope.row.yinxin">
                    <el-option
                      v-for="item in scope.row.baritem"
                      :key="item.unitguid"
                      :label="item.batchno"
                      :value="item.unitguid">
                    </el-option>
                  </el-select>
                  <!--{{getBarcode(scope.row,'batchno')}}-->
                </template>
              </el-table-column>
              <el-table-column
                prop="P"
                label="库存"
                align="center"
                width="70"
                header-align="center">
                <template slot-scope="scope">
                  {{scope.row.yinxin?getBarcode(scope.row,'totalnumber'):scope.row.P}}
                </template>
              </el-table-column>
              <el-table-column
                prop="totalnumber"
                label="数量"
                align="center"
                width="90"
                header-align="center">
                <template slot-scope="scope">
                  <el-input-number :controls="false" style="width: 100%" size="small" v-model="scope.row.totalnumber"
                                   :ref='scope.row.id'
                                   onfocus="this.select()"
                                   @change="totalNumber"></el-input-number>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="100">
                <template slot-scope="scope">
                  <el-button size="mini" type="danger"
                             @click="handleDelete(scope.$index, scope.row)">删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </td>
        </tr>
      </table>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogSeeVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData" :loading="loading">确认</el-button>
    </div>
  </el-dialog>
</template>


<script>


  import {getRemark} from '@/plugin/ordercommon'
  import {getGoodsTree} from '@/api/set/jxcgooddetail';
  import {getGoodsListWithStoreDetail} from '@/api/set/jxcresultstore';
  import {getPrice} from '@/api/set/goodsprice';
  import {getpcustomerserial} from '@/api/set/csagreement';
  import {addstoragebad} from '@/api/set/warehouse'
  import {getListData} from '@/api/set/jxcstore'
  import {cusandptbyind} from '@/api/set/jxcstore';
  import {getDetail} from '@/api/set/jxcstoregoodsbarcode';
  import {getListData as listCert} from '@/api/set/certmanage'

  export default {
    name: 'AddStorageBad',
    msg:'仓库岗 添加坏件（供应商多发、正式库转入）',
    data() {
      return {
        dialogFormVisible: false,
        goodsbarcode:'',
        title: "",
        categorycode:"",
        isyinxin:false,
        index: -99,
        seedgoods: [],
        dialogSeeVisible: false,
        formLabelWidth: '120px',
        groupguid: '',
        remark: '',
        cangkucode: '',
        cangkuname: '',
        ordername:'',
        cangkucodes: [],
        tableData: [
          {column: []},
        ],
        addtype:1,
        tableData1: [],
        unitguid: "",
        column: [],
        ptableData: [],
        controlData: {},
        storenumber:[],
        storenumtable: [],
        totalnumber: 0,//镜架 调拨总数
        showtitle1: "none",
        jxcstoreData: [],
        filltemplate: "",
        num: 0,
        canshowgoodsel: true,
        form: {  //表单数据
          unitguid: "",
          bookstr: "",
          seedcode: "",
          seedname: "",
          applybyguid:"",
          applyby:""
        },
        tracknum: '',//供应商单号
        logisticstracknum: '',//跟踪单号
        loading: false,
        scangoodscode:[]
      }

    },
    methods: { //给tableData 添加 id，共回车使用
      checktree1(guids, names, arr) {
        this.form.applybyguid = guids;
        this.form.applyby = names;
      },
      //删除明细
      handleDelete(index, row) {
        this.tableData.splice(index, 1)
        this.totalNumber()
      },
      getBarcode(row,column) {
        if (!row.yinxin || !row.barcode)
          return '';
        for (let i in row.baritem) {
          if (row.baritem[i].unitguid == row.barcode)
            if (column == 'endtime') {
              return row.baritem[i][column].split(' ')[0];
            }
          return row.baritem[i][column];
        }
        return '';
      },
      indexMethod(index) {
        this.tableData[index].id = index
        return index + 1;
      },
      error(msg) {
        this.$message({
          message: msg,
          type: 'error'
        })
      },
      //购买总数
      totalNumber() {
        this.totalnumber = 0
        for (let i in this.tableData) {
          if(this.tableData[i].totalnumber==undefined)
            continue;
          var num = parseInt(this.tableData[i].totalnumber);
          this.totalnumber = this.totalnumber + num
        }
      },
      //供应商单号输入成功后自动跳到跟踪单号框
      scanTracknum() {
        if (this.tracknum) {
          this.$refs.logisticstracknum.focus()
        }
      },
      //获得标题
      getTitle() {
        let result = "";
        let temp = localStorage.getItem("hpapi_userInfoModel")
        if (temp) {
          result += JSON.parse(temp).tenantname || ""
        }
        result += "坏件入库单"
        return result
      },
      //清空商品
      clearSeedCode() {
        this.scangoodscode=[]
        this.form.seedcode = ""
        this.form.seedname = ""
        this.form.filltemplate = ""
        this.canshowgoodsel = false
      },


      bindData() {
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({filltemplates:'40'})
        })
      },

      //选择供应商
      changepcu(val) {
        for (let i in this.ptableData) {
          if (this.ptableData[i].customerserial == val) {
            this.controlData.pcustomerserial = this.ptableData[i].customerserial
            this.controlData.pcustomer = this.ptableData[i].deptname
            this.controlData.clinkman = this.ptableData[i].linkman
            this.controlData.clinkmantel = this.ptableData[i].linkmantel
            this.controlData.caddress = this.ptableData[i].address
            this.BookContent = []
          }
        }
      },
      //选择商品之后执行
      afterSelectCode(guids, names, arr) {
        if (!guids) return;

        this.form.seedcode = guids
        this.form.seedname = names
        this.filltemplate = arr[0].attributes.filltemplate
        this.categorycode = arr[0].parentId;
        this.afterSelectADD([{seedcode: guids, seedname: names, P: undefined, categorycode: arr[0].parentId}]);

        this.$refs.treeSeed.reset();
        this.form.seedcode = ''
        this.form.seedname = ''
      },
      afterSelectADD(arr) {
        for (var i in arr) {
          this.tableData.push({
            seedcode: arr[i].seedcode,
            seedname: arr[i].seedname,
            categorycode: arr[i].categorycode,
            P: 0,
            totalnumber: arr[i].P,
            formproperty: '[{}]',
            yinxin: false,
            barcode: '',
            baritem: '',
          })
          this.totalnumber += arr[i].P ? arr[i].P : 0;
        }
        this.bindStore();
      },
      bindStore() {
        let yearnow = new Date().getFullYear()
        let monthnow = new Date().getMonth() + 1

        var seedcode="";
        for(let i in this.tableData) {
          var hasValue = false;
          for (let j in this.storenumber) {
            if (this.storenumber[j].seedcode == this.tableData[i].seedcode) {
              hasValue = true;
              break;
            }
          }
          if (!hasValue) {
            seedcode += this.tableData[i].seedcode + ',';
          }
        }
        if(seedcode=='') {
          this.setKucun();
          return;
        }

        getGoodsListWithStoreDetail({
          seedcode: seedcode,//
          minyear: yearnow,
          minmonth: monthnow,
          maxyear: yearnow,
          maxmonth: monthnow,
          nostock: 1,
          nolimit: 1,
          nodeliverying: 1,
          nobuynum: 1,
          cangkucode: this.controlData.cangkucode,
          calculateStore: "1",
          showyinxing: "2"
        }).then(resStore => {

          var barcodeseed=resStore.data.barcodeseed;
          var barcode=resStore.data.barcode;

          for (let i in resStore.data.obj) {
            var seedcode = resStore.data.obj[i].seedcode;
            var row = {
              seedcode: seedcode,
              yinxin: false,
              barcode: [],
              P: resStore.data.obj[i].subtractnum,//库存量
            };
            for (let j in barcodeseed) {
              if (barcodeseed[j] == seedcode) {
                row.yinxin = true;

                for (let m in barcode) {
                  if (barcode[m].seedcode == seedcode) {
                    row.barcode.push(barcode[m]);
                  }
                }
                break;
              }
            }
            this.storenumber.push(row)
          }

          this.setKucun();

        }).catch((error) => {
          console.log(error)
        });
      },
      setKucun() {//库存量
        this.isyinxin = false;
        for (let i in this.tableData) {
          this.tableData[i].yinxin = false;
          for (let j in this.storenumber) {
            if (this.tableData[i].seedcode == this.storenumber[j].seedcode) {
              this.tableData[i].P = 0;
              if (this.storenumber[j].yinxin) {
                this.isyinxin = true;
                this.tableData[i].yinxin = true;
                var bars = this.storenumber[j].barcode;
                this.tableData[i].baritem = bars;

                var existUnitguid = false;
                for (let m in bars) {
                  if (this.tableData[i].barcode && this.tableData[i].barcode == bars[m].unitguid) {
                    existUnitguid = true;
                  }
                }
                if (!existUnitguid) {//切换仓库后 选择的批次号可能会不存在
                  this.tableData[i].barcode = ''
                }
                if(this.tableData[i].barcode==''&&bars.length>0){
                  this.tableData[i].barcode=bars[0].unitguid;//默认第一个
                }
              } else {
                this.tableData[i].P = this.storenumber[j].P;
              }
              break;
            }
          }
        }
      },
      getLiuYan(remark) {
        return getRemark(remark);
      },


      show() {
        this.dialogSeeVisible = true;
      },
      changename(val) {
        for (let i in this.jxcstoreData) {
          if (this.jxcstoreData[i].cangkucode == val) {
            this.controlData.cangkuname = this.jxcstoreData[i].cangkuname;
            this.bindStore();
          }
        }
      },
      contains(item, arr) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i] == item) {
            return true;
          }
        }
        return false;
      },

      getRemark(remark) {
        if (remark) {
          try {
            let temp = JSON.parse(remark)
            temp.forEach(item => {
              if (item.type == "客户留言") {
                return item.msg
              }
            })
          } catch (ex) {
          }
        }
        return ""
      },

      saveData() {
        this.loading = true
        //根据缓存中oddrequired  true需必填否则不必填
        // if (this.addtype==1&&JSON.parse(localStorage.getItem("hpapi_parames")).other.oddrequired == 'true') {
        //   if (!this.logisticstracknum) {
        //     this.$message({
        //       message: '请输入跟踪单号',
        //       type: 'error'
        //     })
        //     this.loading = false
        //     return
        //   }
        //   if (!this.tracknum) {
        //     this.$message({
        //       message: '请输入供应商单号',
        //       type: 'error'
        //     })
        //     this.loading = false
        //     return
        //   }
        // }
        if(!this.form.applybyguid){
          this.$message({
            message: '责任人必选！',
            type: 'error'
          })
          this.loading = false
          return
        }
        if(!this.ordername){
          this.$message({
            message: '请选择入库原因！',
            type: 'error'
          })
          this.loading = false
          return
        }
        if(this.ordername=='其他原因'&&!this.controlData.remark){
          this.$message({
            message: '请填写备注！',
            type: 'error'
          })
          this.loading = false
          return
        }

        var arr = [];
        var barcode = [];
        for (let i in this.tableData) {
          var obj = {}
          obj.seedcode = this.tableData[i].seedcode
          obj.seedname = this.tableData[i].seedname
          obj.barcodes = this.tableData[i].yinxin ? this.tableData[i].barcode : '';
          if (this.tableData[i].yinxin) {
            if (!obj.barcodes) {
              this.errorMessag(obj.seedname + '：必须选批次号！')
              return
            }
          }

          for (let j in arr) {
            if (arr[j].seedcode == obj.seedcode && arr[j].barcodes == obj.barcodes) {
              this.errorMessag(obj.seedname + '：重复增加，请核对！')
              return
            }
          }

          if (this.tableData[i].totalnumber && this.tableData[i].totalnumber != undefined && parseInt(this.tableData[i].totalnumber) > 0) {
            obj.P = this.tableData[i].totalnumber
            arr.push(obj)

            if (this.tableData[i].yinxin) {
              barcode.push({
                seedcode: obj.seedcode,
                seedname: obj.seedname,
                packagesize: "",
                batchno: this.getBarcode(this.tableData[i], 'batchno'),
                certno: this.getBarcode(this.tableData[i], 'certno'),
                certorg: this.getBarcode(this.tableData[i], 'certorg'),
                endtime: this.getBarcode(this.tableData[i], 'endtime'),
                totalnumber: obj.P
              });
            }
          } else {
            this.errorMessag('数量必须填写！')
            return
          }
        }

        var scancodes=JSON.stringify([]);

        if (arr != 0) {
          addstoragebad({
            jxcforms: JSON.stringify(arr),
            map: JSON.stringify({
              pcustomerserial: this.controlData.pcustomerserial,
              pcustomer: this.controlData.pcustomer,
              cangkuname: this.controlData.cangkuname,
              cangkucode: this.controlData.cangkucode,
              address: this.controlData.address,
              linkman: this.controlData.linkman,
              linkmantel: this.controlData.linkmantel,
              seedcode: this.form.seedcode,
              seedname: this.form.seedname,
              remark: this.controlData.remark,
              tracknum: this.tracknum,
              logisticstracknum: this.logisticstracknum,
              addtype: this.addtype,
              ordername: this.ordername,
              applyby: this.form.applyby,
              applybyguid: this.form.applybyguid,
              scancodes: scancodes
            }),
            barcode: barcode.length > 0 ? JSON.stringify(barcode) : ''
          }).then(response => {
            if (response.data.code == 0) {
              this.$message({
                message: '保存成功',
                type: 'success'
              })
              this.$emit('bindGrid');
            } else {
              this.$message({
                message: response.data.msg,
                type: 'error'
              })
            }
            this.dialogSeeVisible = false;
            //刷新列表
          });
          //

        } else {
          this.$message({
            message: '请选择订单',
            type: 'error'
          })
          this.loading = false
        }

      },


      initData(type) {
        this.addtype=type;//1 供应商多发，2 正式转入
        this.initForm()
        if (this.jxcstoreData && this.jxcstoreData.length > 0) {
          this.controlData.cangkucode = this.jxcstoreData[0].cangkucode
          this.controlData.cangkuname = this.jxcstoreData[0].cangkuname
        }

        if (this.$refs.form1 !== undefined) {
          this.$refs.form1.resetFields();
          this.form.bookstr = ""
          this.form.seedcode = ""
          this.form.seedname = ""
        }
      },


      initForm() {
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
        this.canshowgoodsel = true
        this.controlData = {}
        this.groupguid = ""
        this.column = []
        this.ordername=""
        this.tableData = []
        this.unitguid = ""
        this.filltemplate = ""
        this.index = -99
        this.addvisible = true
        this.form.seedcode = ''
        this.form.seedname = ''
        this.form.applyby=''
        this.form.applybyguid=''
        this.num = 0;
        this.loading = false
      }
    },
    mounted() {
      cusandptbyind().then(response => {
        this.jxcstoreData = response.data.obj

      })
    },

    components: {
    }

  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }

  .gray1 td {
    color: #C0C4CC;
    background-color: #ebeef5;
  }

  .gray1 input {
    display: none;
  }

</style>





// WEBPACK FOOTER //
// src/components/warehouse/AddStorageBadOther.vue